import { Component, OnInit } from '@angular/core';

import {LanguageService} from '../../language/language.service';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-bezpieczenstwo',
  templateUrl: './bezpieczenstwo.component.html',
  styleUrls: ['../pages.scss','./bezpieczenstwo.component.scss']
})
export class BezpieczenstwoComponent implements OnInit {

  constructor(
    private meta: Meta,
    private titleService: Title,
    public languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.languageService.getLang('security title', 'seo'));
    this.meta.updateTag({
      name: 'description',
      content: this.languageService.getLang('security desc', 'seo')
    });
  }
}
